import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'

// Lazy import DevTools to avoid SSR issues
const ReactQueryDevtools = React.lazy(() =>
  import('@tanstack/react-query-devtools').then((module) => ({
    default: module.ReactQueryDevtools
  }))
)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000 // 10 minutes (previously cacheTime)
    },
    mutations: {
      retry: 1
    }
  }
})

// Export queryClient for use outside of React components (e.g., Zustand stores)
export { queryClient }

interface QueryProviderProps {
  children: React.ReactNode
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      {children}
    </QueryClientProvider>
  )
}

export default QueryProvider
